<template>
    <div class="dropdown-main-container" @click="onOpenFilter">
        <div class="input date-input">
            <check-circle-icon class="dropdown-left-icon" />
            <p class="dropdown-checked-value">{{ checkedValue }}</p>
            <chevron-down-icon class="dropdown-chevron-icon" :style="[isOpenList && { transform: 'rotate(180deg)' }]" />
        </div>
        <div v-if="isOpenList" class="dropdown-list">
            <vue-perfect-scrollbar class="list-scroll-area">
                <div v-for="option of options" :key="option.id" class="dropdown-item"
                    @click="setIsCheckElement(option)">
                    {{ option.value }}
                </div>
            </vue-perfect-scrollbar>
        </div>
    </div>
</template>

<script>

import {ChevronDownIcon, CheckCircleIcon} from 'vue-feather-icons'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { onVibrate } from '../helpers/utils';

export default {
    name: "Date-filter-list",
    components: {
        CheckCircleIcon,
        ChevronDownIcon,
        VuePerfectScrollbar
    },
    props: {
        value: {
            type: Object,
            require: false
        },
        isCurrency: {
            type: Boolean,
            require: false
        },
        options: {
            type: Array,
            require: false
        },
        analyticsFilter: {
            type: Boolean,
            require: false
        }
    },
    data() {
        return {
          isOpenList: false,
          checkedValue: this.value.value,
        }
    },
    async mounted() {

    },

    methods: {
        setIsOpenList() {
            onVibrate('click')
            this.isOpenList = !this.isOpenList
        },
        setIsCheckElement(el) {
            this.checkedValue = el.value
            this.$emit('set-changed-filter', el)
            // this.$emit('check-list-value', val)
            // if (this.isCurrency) {
            //     this.checkedValue = val.code_alfa
            // } else {
            //     this.checkedValue = val.title
            // }
        },
        onOpenFilter() {
            if (this.analyticsFilter) {
                this.$emit('open-filter')
            } else {
                this.isOpenList = !this.isOpenList
                this.$emit('open-filter')
            }
        }
    },
    computed: {

    },
    watch: {
        value(newVal, oldVal) {
            console.log({newVal})
            this.checkedValue = newVal.value
            let val = oldVal
            val
        }
    }
}
</script>

<style scoped>
    .dropdown-main-container {
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        width: fit-content;
        position: relative;
        width: 100%;
        cursor: pointer;
    }
    .dropdown-main-container .input {
        padding: 11px 40px;
        font-size: 0.75rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        background: transparent;
        height: 45px;
    }
    .dropdown-left-icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 10px;
        width: 17px;
        height: 17px;
    }
    .dropdown-chevron-icon {
        position: absolute;
        right: 10px;
        top: 15px;
        width: 17px;
        height: 17px;
        margin-left: auto;
        transition: all .25s ease;
    }
    .dropdown-list {
        position: absolute;
        width: 100%;
        z-index: 100;
        top: 46px;
        height: 150px;
        background: #f8f8f8;
        border: 1px solid rgba(0, 0, 0, 0.07);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        padding: 10px;
        overflow: hidden;
    }
    .dropdown-checked-value {
        font-weight: 400;
        line-height: 25px;
        font-size: 12px;
        font-family: "Source Sans 3", sans-serif;
        color: #212529;
    }
    .dropdown-item {
        font-weight: 400;
        line-height: 1.5;
        font-size: 15px;
        background: transparent;
        font-family: "Source Sans 3", sans-serif;
        color: #212529;
        padding: 5px 10px;
        transition: all .25s ease;
    }
    .dropdown-item:hover {
        background-image: var(--main-bg-color);
        color: #fff;
        border-radius: 3px;
        padding-left: 14px;
    }
    .list-scroll-area {
        max-height: 135px;
        width: 100%;
    }
</style>

